import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GENERAL_FEATURE_KEY, GeneralState } from './general.reducer';

export const selectGeneralState = createFeatureSelector<GeneralState>(GENERAL_FEATURE_KEY);

export const selectLanguage = createSelector(selectGeneralState, (state: GeneralState) => state.language);

export const selectJansenFilter = createSelector(selectGeneralState, (state: GeneralState) => state.jansenFilter);

export const selectGPTiframe = createSelector(selectGeneralState, (state: GeneralState) => state.GPTiframe);

export const selectIsDownloadDocumentActive = createSelector(
  selectGeneralState,
  (state: GeneralState) => state.isDownloadDocumentActive
);

export const selectDownloadDocumentFilename = createSelector(
  selectGeneralState,
  (state: GeneralState) => state.downloadDocumentFilename
);

export const selectDownloadDocumentId = createSelector(
  selectGeneralState,
  (state: GeneralState) => state.downloadDocumentId
);
